import { render, staticRenderFns } from "./PersonalReferences.vue?vue&type=template&id=437ae56a&"
import script from "./PersonalReferences.vue?vue&type=script&lang=js&"
export * from "./PersonalReferences.vue?vue&type=script&lang=js&"
import style0 from "./PersonalReferences.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports